import { render, staticRenderFns } from "./ApplicationPage.vue?vue&type=template&id=a221f88e&scoped=true&"
import script from "./ApplicationPage.vue?vue&type=script&lang=js&"
export * from "./ApplicationPage.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPage.vue?vue&type=style&index=0&id=a221f88e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a221f88e",
  null
  
)

export default component.exports